var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 1024",
    fill: "none",
    preserveAspectRatio: "xMidYMid slice",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_5257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.4 479.804L578.4 341.363L441.6 518.439L602.4 479.804Z",
    fill: "#F5F5F5",
    stroke: "#F5F5F5",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.4 186.824L333.6 499.122L441.6 518.439L398.4 186.824Z",
    fill: "#EDEDED",
    stroke: "#EDEDED",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.6 518.439L420 672.978L602.4 479.804L441.6 518.439Z",
    fill: "#F5F5F5",
    stroke: "#F5F5F5",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.6 499.122L420 672.978L441.6 518.439L333.6 499.122Z",
    fill: "#F1F1F1",
    stroke: "#F1F1F1",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.4 341.363L398.4 186.824L441.6 518.439L578.4 341.363Z",
    fill: "#EEEEEE",
    stroke: "#EEEEEE",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.4 186.824L259.2 260.874L333.6 499.122L398.4 186.824Z",
    fill: "#E7E7E7",
    stroke: "#E7E7E7",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.4 186.824L278.4 90.2372L259.2 260.874L398.4 186.824Z",
    fill: "#E0E0E0",
    stroke: "#E0E0E0",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.8 -19.2279L405.6 64.4807L398.4 186.824L580.8 -19.2279Z",
    fill: "#E2E2E2",
    stroke: "#E2E2E2",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.4 341.363L580.8 -19.2279L398.4 186.824L578.4 341.363Z",
    fill: "#E8E8E8",
    stroke: "#E8E8E8",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.4 479.804L789.6 283.411L578.4 341.363L602.4 479.804Z",
    fill: "#F6F6F6",
    stroke: "#F6F6F6",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.6 434.73L789.6 283.411L602.4 479.804L825.6 434.73Z",
    fill: "#F9F9F9",
    stroke: "#F9F9F9",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.8 711.613L825.6 434.73L602.4 479.804L772.8 711.613Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 672.978L631.2 824.298L602.4 479.804L420 672.978Z",
    fill: "#F5F5F5",
    stroke: "#F5F5F5",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.2 824.298L772.8 711.613L602.4 479.804L631.2 824.298Z",
    fill: "#F9F9F9",
    stroke: "#F9F9F9",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 672.978L576 920.885L631.2 824.298L420 672.978Z",
    fill: "#F1F1F1",
    stroke: "#F1F1F1",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.6 499.122L247.2 705.174L420 672.978L333.6 499.122Z",
    fill: "#EDEDED",
    stroke: "#EDEDED",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 550.635L247.2 705.174L333.6 499.122L120 550.635Z",
    fill: "#EAEAEA",
    stroke: "#EAEAEA",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.6 283.411L580.8 -19.2279L578.4 341.363L789.6 283.411Z",
    fill: "#EEEEEE",
    stroke: "#EEEEEE",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.6 64.4807L278.4 90.2372L398.4 186.824L405.6 64.4807Z",
    fill: "#DFDFDF",
    stroke: "#DFDFDF",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.8 -186.645L278.4 90.2372L405.6 64.4807L268.8 -186.645Z",
    fill: "#D8D8D8",
    stroke: "#D8D8D8",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.2 824.298L746.4 914.445L772.8 711.613L631.2 824.298Z",
    fill: "#F8F8F8",
    stroke: "#F8F8F8",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.8 965.958L576 920.885L420 672.978L328.8 965.958Z",
    fill: "#ECECEC",
    stroke: "#ECECEC",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.6 283.411L811.2 70.9198L580.8 -19.2279L789.6 283.411Z",
    fill: "#EDEDED",
    stroke: "#EDEDED",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.8 196.483L811.2 70.9198L789.6 283.411L928.8 196.483Z",
    fill: "#EEEEEE",
    stroke: "#EEEEEE",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.2 260.874L120 550.635L333.6 499.122L259.2 260.874Z",
    fill: "#E8E8E8",
    stroke: "#E8E8E8",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 296.289V550.635L259.2 260.874L120 296.289Z",
    fill: "#E3E3E3",
    stroke: "#E3E3E3",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.4 90.2372L120 296.289L259.2 260.874L278.4 90.2372Z",
    fill: "#DEDEDE",
    stroke: "#DEDEDE",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 920.885L746.4 914.445L631.2 824.298L576 920.885Z",
    fill: "#F4F4F4",
    stroke: "#F4F4F4",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.8 425.072L928.8 196.483L825.6 434.73L1024.8 425.072Z",
    fill: "#F4F4F4",
    stroke: "#F4F4F4",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.2 705.174L328.8 965.958L420 672.978L247.2 705.174Z",
    fill: "#E9E9E9",
    stroke: "#E9E9E9",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 920.884L760.8 1155.91L746.4 914.445L576 920.884Z",
    fill: "#F3F3F3",
    stroke: "#F3F3F3",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.6 956.3L328.8 965.958L247.2 705.174L153.6 956.3Z",
    fill: "#E4E4E4",
    stroke: "#E4E4E4",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.4 804.98L825.6 434.73L772.8 711.613L926.4 804.98Z",
    fill: "#F9F9F9",
    stroke: "#F9F9F9",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.6 434.73L928.8 196.483L789.6 283.411L825.6 434.73Z",
    fill: "#F3F3F3",
    stroke: "#F3F3F3",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.8 965.958L405.6 1062.55L576 920.885L328.8 965.958Z",
    fill: "#E9E9E9",
    stroke: "#E9E9E9",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.8 -19.228L499.2 -225.28L405.6 64.4807L580.8 -19.228Z",
    fill: "#DDDDDD",
    stroke: "#DDDDDD",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.8 -205.963L580.8 -19.2279L811.2 70.9198L796.8 -205.963Z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.4 90.2372L62.4 67.7003L120 296.289L278.4 90.2372Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.4 914.445L926.4 804.98L772.8 711.613L746.4 914.445Z",
    fill: "#F6F6F6",
    stroke: "#F6F6F6",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.4 804.98L1024.8 425.072L825.6 434.73L926.4 804.98Z",
    fill: "#FAFAFA",
    stroke: "#FAFAFA",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 550.635L43.2 705.174H247.2L120 550.635Z",
    fill: "#E5E5E5",
    stroke: "#E5E5E5",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.8 965.958L295.2 1213.86L405.6 1062.55L328.8 965.958Z",
    fill: "#E3E3E3",
    stroke: "#E3E3E3",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-120 454.048L43.2 705.174L120 550.635L-120 454.048Z",
    fill: "#E2E2E2",
    stroke: "#E2E2E2",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.2 -225.28L268.8 -186.645L405.6 64.4807L499.2 -225.28Z",
    fill: "#D6D6D6",
    stroke: "#D6D6D6",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.8 -186.645L62.4 67.7003L278.4 90.2372L268.8 -186.645Z",
    fill: "#D4D4D4",
    stroke: "#D4D4D4",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 296.289L-120 454.048L120 550.635V296.289Z",
    fill: "#E1E1E1",
    stroke: "#E1E1E1",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 705.174L153.6 956.3L247.2 705.174H43.2Z",
    fill: "#E2E2E2",
    stroke: "#E2E2E2",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.6 -41.7649L796.8 -205.963L811.2 70.9198L1017.6 -41.7649Z",
    fill: "#E3E3E3",
    stroke: "#E3E3E3",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.6 -41.7649L811.2 70.9198L928.8 196.483L1017.6 -41.7649Z",
    fill: "#E8E8E8",
    stroke: "#E8E8E8",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.4 914.445L1010.4 927.324L926.4 804.98L746.4 914.445Z",
    fill: "#F3F3F3",
    stroke: "#F3F3F3",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.6 1265.38L760.8 1155.91L576 920.885L585.6 1265.38Z",
    fill: "#EFEFEF",
    stroke: "#EFEFEF",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.2 215.8L1017.6 -41.7649L928.8 196.483L1219.2 215.8Z",
    fill: "#E7E7E7",
    stroke: "#E7E7E7",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212 714.832L1161.6 463.707L1024.8 425.072L1212 714.832Z",
    fill: "#F6F6F6",
    stroke: "#F6F6F6",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.8 1155.91L1010.4 927.324L746.4 914.445L760.8 1155.91Z",
    fill: "#F2F2F2",
    stroke: "#F2F2F2",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.6 956.3L295.2 1213.86L328.8 965.958L153.6 956.3Z",
    fill: "#E1E1E1",
    stroke: "#E1E1E1",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.6 1062.55L585.6 1265.38L576 920.885L405.6 1062.55Z",
    fill: "#EAEAEA",
    stroke: "#EAEAEA",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 705.174L-57.6 962.739L153.6 956.3L43.2 705.174Z",
    fill: "#DDDDDD",
    stroke: "#DDDDDD",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-136.8 334.924L-120 454.048L120 296.289L-136.8 334.924Z",
    fill: "#DCDCDC",
    stroke: "#DCDCDC",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.8 -186.645L45.6 -148.01L62.4 67.7003L268.8 -186.645Z",
    fill: "#CECECE",
    stroke: "#CECECE",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3999 67.7003L-136.8 334.924L120 296.289L62.3999 67.7003Z",
    fill: "#D7D7D7",
    stroke: "#D7D7D7",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.8 425.072L1219.2 215.8L928.8 196.483L1024.8 425.072Z",
    fill: "#EEEEEE",
    stroke: "#EEEEEE",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212 714.832L1024.8 425.072L926.4 804.98L1212 714.832Z",
    fill: "#F5F5F5",
    stroke: "#F5F5F5",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69.6001 12.9677L-136.8 334.924L62.3999 67.7003L-69.6001 12.9677Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6 -148.01L-69.6 12.9677L62.4 67.7003L45.6 -148.01Z",
    fill: "#CCCCCC",
    stroke: "#CCCCCC",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-127.2 840.395L43.2001 705.174L-120 454.048L-127.2 840.395Z",
    fill: "#DFDFDF",
    stroke: "#DFDFDF",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-127.2 840.395L-57.5999 962.739L43.2001 705.174L-127.2 840.395Z",
    fill: "#DCDCDC",
    stroke: "#DCDCDC",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.6 956.3L146.4 1268.6L295.2 1213.86L153.6 956.3Z",
    fill: "#DCDCDC",
    stroke: "#DCDCDC",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.6 962.739L146.4 1268.6L153.6 956.3L-57.6 962.739Z",
    fill: "#DADADA",
    stroke: "#DADADA",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.6 463.707L1219.2 215.8L1024.8 425.072L1161.6 463.707Z",
    fill: "#F0F0F0",
    stroke: "#F0F0F0",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.4 927.324L1212 714.833L926.4 804.98L1010.4 927.324Z",
    fill: "#F2F2F2",
    stroke: "#F2F2F2",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.6 463.707L1298.4 476.585L1219.2 215.8L1161.6 463.707Z",
    fill: "#EFEFEF",
    stroke: "#EFEFEF",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.8 1155.91L964.8 1210.65L1010.4 927.324L760.8 1155.91Z",
    fill: "#EEEEEE",
    stroke: "#EEEEEE",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.4 927.324L1224 1043.23L1212 714.833L1010.4 927.324Z",
    fill: "#EEEEEE",
    stroke: "#EEEEEE",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6 -148.01L-144 -167.328L-69.6 12.9677L45.6 -148.01Z",
    fill: "#C8C8C8",
    stroke: "#C8C8C8",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.2 215.8L1212 25.8459L1017.6 -41.7649L1219.2 215.8Z",
    fill: "#E3E3E3",
    stroke: "#E3E3E3",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212 25.8459L1142.4 -186.645L1017.6 -41.7649L1212 25.8459Z",
    fill: "#DDDDDD",
    stroke: "#DDDDDD",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212 714.832L1298.4 476.585L1161.6 463.707L1212 714.832Z",
    fill: "#F4F4F4",
    stroke: "#F4F4F4",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.2 215.8L1336.8 199.702L1212 25.8459L1219.2 215.8Z",
    fill: "#E4E4E4",
    stroke: "#E4E4E4",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.4 476.585L1336.8 199.702L1219.2 215.8L1298.4 476.585Z",
    fill: "#EAEAEA",
    stroke: "#EAEAEA",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212 25.8459L1315.2 -209.182L1142.4 -186.645L1212 25.8459Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212 714.832L1368 747.028L1298.4 476.585L1212 714.832Z",
    fill: "#F1F1F1",
    stroke: "#F1F1F1",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.4 476.585L1504.8 199.702H1336.8L1298.4 476.585Z",
    fill: "#E8E8E8",
    stroke: "#E8E8E8",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.8 1210.65L1224 1043.23L1010.4 927.324L964.8 1210.65Z",
    fill: "#ECECEC",
    stroke: "#ECECEC",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.6 962.739L-79.2 1284.7L146.4 1268.6L-57.6 962.739Z",
    fill: "#D5D5D5",
    stroke: "#D5D5D5",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.8 199.702L1329.6 -3.13013L1212 25.8459L1336.8 199.702Z",
    fill: "#E1E1E1",
    stroke: "#E1E1E1",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.6 1046.45L1368 747.028L1212 714.833L1281.6 1046.45Z",
    fill: "#EDEDED",
    stroke: "#EDEDED",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.8 199.702H1504.8L1329.6 -3.13013L1336.8 199.702Z",
    fill: "#E1E1E1",
    stroke: "#E1E1E1",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224 1043.23L1281.6 1046.45L1212 714.833L1224 1043.23Z",
    fill: "#ECECEC",
    stroke: "#ECECEC",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.6 -3.13013L1315.2 -209.182L1212 25.8459L1329.6 -3.13013Z",
    fill: "#DBDBDB",
    stroke: "#DBDBDB",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.4 946.641L1572 682.637L1368 747.028L1538.4 946.641Z",
    fill: "#EBEBEB",
    stroke: "#EBEBEB",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.8 544.196L1298.4 476.585L1368 747.028L1588.8 544.196Z",
    fill: "#F0F0F0",
    stroke: "#F0F0F0",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.8 544.196L1504.8 199.702L1298.4 476.585L1588.8 544.196Z",
    fill: "#ECECEC",
    stroke: "#ECECEC",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.4 946.641L1281.6 1046.45L1548 1213.86L1538.4 946.641Z",
    fill: "#E5E5E5",
    stroke: "#E5E5E5",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.4 946.641L1368 747.028L1281.6 1046.45L1538.4 946.641Z",
    fill: "#E9E9E9",
    stroke: "#E9E9E9",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572 682.637L1588.8 544.196L1368 747.028L1572 682.637Z",
    fill: "#EEEEEE",
    stroke: "#EEEEEE",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.8 199.702L1574.4 80.5785L1329.6 -3.13013L1504.8 199.702Z",
    fill: "#DEDEDE",
    stroke: "#DEDEDE",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.4 80.5785L1531.2 -154.45L1329.6 -3.13013L1574.4 80.5785Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9",
    strokeWidth: 1.51
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_5257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1287.83,
    fill: "white",
    transform: "translate(0 -131.913)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangles);
export default __webpack_public_path__ + "static/media/triangles.a9b37b7ac4281402e1ee6971e02ede63.svg";
export { ForwardRef as ReactComponent };